/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import { ConfirmButtonActions, Reportedperiod/*, ReportedPeriodReportType*/ } from "./editTypes";
import { DataService } from "../../services/DataService";
import { InvoiceReport } from "../../services/API/InvoiceReports";
import { Department } from "../../services/API/Departments";

interface ReportPreviewProps {
  onSelected: (
    period:string,item:any,reportType:'InvoiceReport' | 'NullReport',action:ConfirmButtonActions,supplierOrgId:string,child:boolean,batchId?:string,departmentId?:number
  ) => void;
  data: Reportedperiod[];
  departmentId?: number | null;
  item: any;
  period: string;
  index: number;
  departments?:Department[];
  
}
type CheckBox = {
  [key:number /*string*/]: boolean;
};
export const ReportPreview = ({
  onSelected,
  data,
  departmentId,
  item,
  period,
  index,
  departments
}: ReportPreviewProps) => {
  const [selected, setSelected] = React.useState<CheckBox>({});
  const [reports, setReports] = React.useState<InvoiceReport[] | undefined>([]);
  const [load, setLoad] = React.useState<boolean>(true);
  const bigBox = React.useRef<HTMLDivElement>(null);
 // Effect to scroll the tooltip into view when it mounts
   React.useEffect(() => {
     if (bigBox.current) {
        bigBox.current.scrollIntoView({
         behavior: "smooth",
         block: "end",
       });
     }
   }, []);
  React.useEffect(() => {
     /**
   * Fetches invoice report overview data and initializes the component state.
   * It retrieves batch IDs from `data`, fetches reports, and updates the selection state.
   */
    const fetchDataAndInitialize = async () => {
      try {
        const batchIds = data.map((q) => q.batchId);
        const fetchedReports =
          await DataService.EditedReports.GetInvoiceReportOverView(batchIds);
      setSelected((prevSelected) => {
        const nullReports = data.filter(x => x.type == 'NullReport');
        const allReports = [...(fetchedReports || []), ...nullReports];

        
        const newCheckBoxState: CheckBox = allReports.reduce((acc: CheckBox, item,index) => {
          acc[/*item.batchId == null ? item.supplierOrgId :item.batchId*/index] = prevSelected[/*item.batchId == null ? item.supplierOrgId :item.batchId*/index] ?? false;
          return acc;
        }, {});

        return newCheckBoxState;
      });
      
        setReports(fetchedReports);
        setLoad(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAndInitialize();
  }, [data]);
 /**
 * Handles checkbox selection for a given batch.
 * Updates the selected state and triggers the selection handler.
 * @param batchId - The ID of the batch being selected.
 */
  const onClick = (supplierOrgId:string,reportType:'InvoiceReport' | 'NullReport',index:number,batchId?: string,departmentId?:number) => {
    let check = structuredClone(selected);
    Object.keys(check).forEach((x) => {
    check[+x] = index == +x ? !check[index] : false;
    });

    setSelected(check);
    //console.log('**************värde på action******************',check[index] ? 'PUSH' : 'POP')
    onSelected(period, item,  reportType,check[index] ? 'PUSH' : 'POP',supplierOrgId,true,batchId,departmentId);
  };
  const renderTabs = () => {
    const nullReports = data.filter(x => x.type == 'NullReport');
    const allReports = [...(reports || []), ...nullReports];
    return (
        
        <Tabs  id="uncontrolled-tab-example" className="mb-3">
          {allReports.map((item, index) => {
            const reportType = index < (reports?.length || 0) ? 'InvoiceReport' : 'NullReport';
            return tabContent(item, reportType, index);
          })}
        </Tabs>
        
      );
  }
  const tabContent = (item:any,reportType:'InvoiceReport' | 'NullReport',index:number):JSX.Element => {
    const departmentName = departments?.find(x => x.id == item.departmentId);
    return(
        <Tab  eventKey={`${index + 1}.`} title={`${index + 1}.`}>
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{borderBottom:'1px solid white'}}>{reportType == 'InvoiceReport' ? 'Statistikrapport' : 'Nollrapport'}</p>
            <div
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "row",
              }}
            >
              Avdelning :{" "}
            </div>
            {item?.departmentId == null ? (
              "Inget avdelningsid"
            ) : (
            <p  style={{background:'rgb(248, 176, 51)',margin:0}}>{departmentName?.department ?? item.departmentId}</p>
            )}
            <>
            {reportType == 'InvoiceReport' && (
                <div>
                   
                <p style={{ margin: 0 }}>
              Inrapporterad : {item?.reportDate.toString()}
            </p>
            <p style={{ margin: 0 }}>Rapporterad av :</p>
            <p style={{ margin: 0 }}>{item?.reporter}</p>
                </div>
                )
            }
           {reportType == 'NullReport' && (
            <div>
                    Ändringen kommer att ta bort nollrapporteringen för {period}.
                    Samt skapa upp en ny statistikrapport.
                    Glöm inte att skicka in kickbackrapporten som skapas upp efter att alla ändringar är inskickade.
            </div>
           )}
            
            </>
          </div>

          <div
        
            className="checkYeah"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              borderTop: "1px solid white",
              marginTop: 5,
            }}
          >
            <p
              style={{
                marginLeft: 4,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                padding: 0,
              }}
            >
              Bekräfta
            </p>
            <FontAwesomeIcon
            
              onClick={() => onClick( item.supplierOrgId,reportType,index,item.batchId,item.departmentId)}
              icon="square-check"
              style={{
                cursor: "pointer",
                color: selected[/*item.batchId == null ? item.supplierOrgId :item.batchId*/index]
                  ? "rgb(146, 192, 31)"
                  : "rgba(179, 4, 4)",
                height: 20,
                width: 20,
              }}
            />
          </div>
        </>
      </Tab>
    )
  }

  return (
    <div
        ref={bigBox}
      style={{
        zIndex: 100,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* Hittade flera statistikrapporter för vald period. Välj vilken rapport
      faktura-raden ska flyttas till. */}
      Hittade flertalet rapporter för vald period.
      Välj nedan.
      <div  style={{ marginTop: 5 }}>
        {load ? (
          <Spinner />
        ) : (
            <>{renderTabs()}</>
        )}
      </div>
    </div>
  );
};
